const INIT_STATE = { data: [], error: null };
export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case "INFORMATIONAL_VIDEOS_SUCCESS":
      return {
        ...state,
        data: action.payload.data,
        error: null,
      };
    case "INFORMATIONAL_VIDEOS_ERROR":
      return { ...state, data: [], error: action.payload };
    default:
      return state;
  }
};
